import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const SuppliersSelectionModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=dPA7SbWT47Y&ab_channel=apadua" />
);

export default SuppliersSelectionModal;
